import React from 'react';
import cn from 'classnames';

import Skeleton from 'coreComponents/Skeleton';

import ProductPrice from 'brandComponents/product/ProductPrice';

import {useProductHitContext} from '../../ProductHitContext';

import {IProductHitPrice} from './IProductHitPrice';

import styles from './ProductHitPrice.module.scss';

const ProductHitPrice = ({classNames, priceModel, showSalesInParenthesis = false}: IProductHitPrice) => {
	const {product} = useProductHitContext();

	if (!product) {
		return <Skeleton classNames={styles['product-hit__price-skeleton']} height="20px" width="60px" />;
	}

	return (
		<ProductPrice
			product={product}
			classNames={{
				productPrice: cn(classNames?.productPrice, styles['product-hit__price']),
				vatIncluded: cn(classNames?.vatIncluded)
			}}
			/* @ts-ignore */
			priceModel={priceModel || product.getPriceModel()}
			showSalesInParenthesis={showSalesInParenthesis}
		/>
	);
};

export default ProductHitPrice;
